import React from "react";
import styles from "./TipInput.module.css";

const TipInput = ({ children }) => {
  return <p className={styles.tipInput}>{children}</p>;
};

export default TipInput;
